<template>
    <v-app class="pa-0">
      <headerPlan />
      <v-container
          class="text-center"
          :class="{ 'pa-0 py-7 body': !isMobile && !isTablet, 'body-resp': isMobile || isTablet}"
      >
          <div class="d-flex justify-center align-center">
              <v-card class="pa-5" width="400">
                  <img
                      :src="require(isShopSuccess ? '@/assets/plans/success.png' : '@/assets/plans/unsucessfull.png')"
                      style="width: 90px;"
                  />
                  <v-card-text class="pa-0 text-h3 mt-4">
                      {{ isShopSuccess ? $t('thanks for buying') : $t('failure') }}
                  </v-card-text>
                  <v-card-text class="pa-0 text-body-1 mt-5">
                      {{ $route.query.message }}
                  </v-card-text>
                  <v-card-text class="text-body-1" v-if="isShopSuccess">
                      {{ $t('tracking-code') + ':' + $route.query.ref_id }}
                  </v-card-text>
                  <v-btn
                      color="primary"
                      class="mt-5"
                      @click="backToPanel"
                  >
                      {{ $t('back') }}
                  </v-btn>
              </v-card>
          </div>
      </v-container>
      <footerPlan />
    </v-app>
</template>

<script>
import headerPlan from '@/views/dashboard/pages/plans/partial/headerPlan.vue'
import footerPlan from '@/views/dashboard/pages/plans/partial/footerPlan.vue'
export default {
  data () {
    return {
      isShopSuccess: false
    }
  },
  components: {
    headerPlan,
    footerPlan
  },
  mounted () {
    if (this.$route.query.status) {
      if (this.$route.query.status == 'true') {
        this.isShopSuccess = true
      } else {
        this.isShopSuccess = false
      }
    }
  },
  methods: {
    backToPanel () {
      if (this.$route.query.source) {
        if (this.$route.query.source == 'android') {
          window.location.href = 'abriron://com.abriron.p3integrator'
        } else {
          this.$router.push({ path: '/' })
        }
      }
    }
  }
}
</script>

<style scoped>
.body {
  padding-right: 150px !important;
  padding-left: 150px !important;
  background-color: #f3f3f3;
  height: 100%;
}
.body-resp {
    background-color: #f3f3f3;
}
.v-card__text {
    width: auto;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
